export const CSV_FILE_NAME = {
  memberList: 'flc-users-',
  memberListAgent: 'flc-users-',
  measureList: 'flc-measurements-',
}
